/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useState, useRef, useEffect } from 'react';
import { Rect, Stage, Layer } from 'react-konva';
import Playhead from './Playhead';
// eslint-disable-next-line no-unused-vars
import SoundShape from './SoundShape';
// import TestSynth from './TestSynth';
import Grid from './Grid';
import SoundBanks from './SoundBanks';
import Konva from 'konva';

import shapeList from './SoundShapes';

Konva.pixelRatio = 1;

const minNormFreq = 0.5;
const maxNormFreq = 2;

export function clampNumber (number, a, b) {
  return Math.max(Math.min(number, Math.max(a, b)), Math.min(a, b));
}

export function positionToNormFreq (position, height) {
  const normFreq = mapRange(position, height, 0, minNormFreq, maxNormFreq);
  return normFreq;
};

export const mapRange = (value, inMin, inMax, outMin, outMax) => {
  return (value - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
};

const textureList = Object.keys(SoundBanks[0]);

const useKeyPress = (targetKey) => {
  const [keyPressed, setKeyPressed] = useState(false);

  useEffect(() => {
    const downHandler = ({ key }) => {
      if (key === targetKey) {
        setKeyPressed(true);
      }
    };

    const upHandler = ({ key }) => {
      if (key === targetKey) {
        setKeyPressed(false);
      }
    };

    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);

    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, [targetKey]);

  return keyPressed;
};

function PlayStage (props) {
  // const testSynthRef = useRef();

  const [shapes, setShapes] = useState([]); // TODO: check if two arrays are needed
  const shapeRefs = useRef([]); // TODO: check if two arrays are needed

  // const layerRef = useRef();

  const [selectedId, setSelectedId] = useState();
  const spaceBarPressed = useKeyPress(' ');

  const [isPlaying, setIsPlaying] = useState(false);
  const [frameRate, setFrameRate] = useState(30); // set initial frame rate to 30 fps

  useEffect(() => {
    if (spaceBarPressed) {
      togglePlay();
    }
  }, [spaceBarPressed]);

  useEffect(() => {
    console.log('Resetting...');
    reset();
  }, [props.resetTrigger]);

  useEffect(() => {
    handleFrameRateChange(frameRate);
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.keyCode === 46) { // check for delete key
        // console.log('Delete key pressed!');
        selectedId && (removeSelectedShape());
      }
      if (event.code === 'Space') {
        event.preventDefault();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedId]);

  // const handleRectangleClick = (i) => {
  //   // const ref = shapeRefs.current[i];
  //   // const note = ref.getNote();
  //   console.log('click: ');
  //   setSelectedId(null);
  //   // testSynthRef.current.synth().triggerRelease();
  //   // inputRef.current.focus();
  // };

  const togglePlay = () => {
    // console.log(isPlaying);
    isPlaying && (props.samplePlayerRef.current.stopAll());
    setIsPlaying(!isPlaying);
  };

  const reset = () => {
    shapes.forEach(shape => {
      console.log('removing sampler for shape: ' + shape.id);
      props.samplePlayerRef.current.removeSampler(shape.id);
    });
    setShapes([]);
    shapeRefs.current = [];
    selectShape(null);
  };

  function handleStartPlay (id) { // TODO: rename to handleStartPlayShape
    startPlaying(id);
  };

  function handleStopPlay (id) { // TODO: rename to handleStopPlayShape
    const idx = shapeIdToIdx(id);
    const ref = shapeRefs.current[idx];
    if (ref.getIsPlaying()) {
      stopPlaying(id);
    }
  }

  const startPlaying = (id) => { // TODO: rename
    // console.log('handlePlay', i);
    const idx = shapeIdToIdx(id);
    const shape = shapeRefs.current[idx];

    if (!shape.getIsPlaying()) {
      shape.setIsPlaying(true);
      const playbackRate = shape.getNormFreq();
      props.samplePlayerRef.current.play(id, playbackRate);
      // console.log('playbackRate', sampler.playbackRate);
    }
    // synth.current().triggerAttack([ref.getNote()] );
  };

  // eslint-disable-next-line no-unused-vars
  const handleAmplitudeChange = (id, amplitude) => {
    props.samplePlayerRef.current.setGain(id, amplitude);
  };

  // eslint-disable-next-line no-unused-vars
  const handleFreqChange = (id, freq) => {
    const clampedFreq = clampNumber(freq, minNormFreq, maxNormFreq);
    props.samplePlayerRef.current.setFreq(id, clampedFreq);
  };
  // handles the  end of playing a shape
  const stopPlaying = (id) => { // TODO: rename
    // console.log('handleStopPlay', i);
    const idx = shapeIdToIdx(id);
    const ref = shapeRefs.current[idx];
    if (ref.getIsPlaying) {
      props.samplePlayerRef.current.stop(id);
      ref.setIsPlaying(false);
    }
  };

  const addShape = (x, y) => {
    const texture = SoundBanks[props.selectedSoundBankIndex][textureList[props.selectedTextureIndex]];
    const shape = shapeList[props.selectedFormIndex];
    const id = `${shape}_${texture.name}_${Date.now()}`;
    if (shape === 'triangleLeft' || shape === 'triangleRight') {
      x = x - 50;
      y = y - 50;
    }

    const initShape = {
      width: props.height / 6,
      height: props.height / 6,
      fill: texture.color.value,
      texture,
      shape,
      x,
      y,
      id,
      normFreq: positionToNormFreq(y, props.height)
    };

    props.samplePlayerRef.current.addSampler(id, texture, true, 0);
    setShapes([...shapes, initShape]);
  };

  const removeSelectedShape = () => {
    removeShape(selectedId);
    selectShape(null);
    // console.log(shapes);
  };

  const removeShape = (id) => {
    const idx = shapeIdToIdx(id);
    shapeRefs.current.splice(idx, 1);
    props.samplePlayerRef.current.removeSampler(id);
    const newShapes = shapes.toSpliced(idx, 1);
    setShapes(newShapes);
    console.log(shapes.length);
  };

  const shapeIdToIdx = (shapeId) => {
    const shapeIdx = shapeRefs.current.findIndex(item => item?.getId() === shapeId);
    return shapeIdx;
  };

  const handleStageClick = (e) => {
    const stage = e.target.getStage();
    const emptySpace = e.target === stage;
    if (!emptySpace) {
      // console.log(testSynthRef.current.setAmplitude(0));
    } else {
      // selectShape(null);
      const x = stage.getRelativePointerPosition().x;
      const y = stage.getRelativePointerPosition().y;
      addShape(x, y);
    }
  };

  const selectShape = (selectedShapeId) => {
    setSelectedId(selectedShapeId);
  };

  const handleFrameRateChange = () => {
    setFrameRate();
  };

  // eslint-disable-next-line no-unused-vars
  const handleSoundShapeChange = (i, newAttrs) => {
    const soundShapes = shapes.slice();
    const soundShape = Object.assign({}, soundShapes[i], newAttrs);
    const newNormFreq = positionToNormFreq(soundShape.y, props.height);
    soundShape.normFreq = newNormFreq; // TODO: check why this does have no effect
    shapeRefs.current[i].setNormFreq(newNormFreq);
    soundShapes[i] = soundShape;
    setShapes(soundShapes);
  };

  return (
    <Stage
          width={props.width}
          height={props.height}
          scale= {props.scale}
          onClick={handleStageClick}
    >
      <Layer listening={false} >
        <Rect
          key='background'
          fill='#F5F5F5'
          width={props.width / props.scale.x}
          height={props.height / props.scale.y}
        ></Rect>
      {/* <Rect
          x={props.width / 24 / props.scale.x}
          y={props.width / 24 / props.scale.x}
          width={props.width / 10 / props.scale.x}
          height={props.width / 10 / props.scale.x}
          fill='red'
      >
      </Rect> */}
      </Layer>
      <Layer listening={false} >
        <Grid
          width={props.width / props.scale.x}
          height={props.height / props.scale.y}
          gridSize={props.height / props.scale.y / 24}>
        </Grid>
      </Layer>
      <Layer
          ref={props.shapesLayerRef}
          frameRate={frameRate}
          // frameRate={frameRate} // set the frame rate dynamically based on state
      >

          {/* <Text text={'Cursor Position: ' + cursor.x + ',' + cursor.y} x={10} y={10} fontSize={20} /> */}
          {shapes.length > 0 && shapes.map((shape, i) => (
            // <Rect
            //   x={shape.x}
            //   y={shape.y}
            //   width={shape.width}
            //   height={shape.height}
            //   key={i}
            //   fill={'black'}
            // >
            // </Rect>
            <SoundShape
                key={shape.id}
                // eslint-disable-next-line no-return-assign
                ref={el => shapeRefs.current[i] = el}
                shapeProps={shape} // TODO: pass only the shape props
                isSelected={shape.id === selectedId}
                onSelect={() => {
                  selectShape(shape.id);
                } }
                onChange={(newAttrs) => handleSoundShapeChange(i, newAttrs)}
                normFreq={shape.normFreq}
                playSound={() => startPlaying(shape.id)}
                onNormFreqChange={() => handleFreqChange(shape.id, shapeRefs.current[i].getNormFreq())}
                onAmplitudeChange={() => handleAmplitudeChange(shape.id, shapeRefs.current[i].getAmplitude())}
            ></SoundShape>
          ))}
          <Playhead
              color='white'
              shapeRefs={shapeRefs}
              onStartPlay={handleStartPlay}
              onStopPlay={handleStopPlay}
              layerRef={props.shapesLayerRef}
              tempo={props.tempo}
              // x={playHeadPosition}
              animating={isPlaying}
          ></Playhead>
      </Layer>
    </Stage>
  );
};

export default React.memo(PlayStage);
